import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Package } from "lucide-react";
import api, { formatBRL } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const STATUS_LABEL = {
  pending: "Aguardando pagamento", paid: "Pago", shipped: "Enviado",
  delivered: "Entregue", cancelled: "Cancelado",
};

export default function Account() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/orders").then((r) => setOrders(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-[1100px] mx-auto px-5 md:px-10 py-14">
      <div className="overline text-[#B89C65] mb-3">Minha conta</div>
      <h1 className="font-serif text-5xl text-[#1A1A1A]">Olá, {user?.name?.split(" ")[0]}</h1>
      <p className="text-[#1A1A1A]/60 mt-2">{user?.email}</p>

      <h2 className="font-serif text-3xl text-[#1A1A1A] mt-14 mb-6">Meus pedidos</h2>
      {loading ? (
        <p className="text-[#1A1A1A]/50">Carregando…</p>
      ) : orders.length === 0 ? (
        <div data-testid="no-orders" className="border border-[#1A1A1A]/10 p-12 text-center">
          <Package size={40} strokeWidth={1} className="mx-auto text-[#1A1A1A]/30" />
          <p className="text-[#1A1A1A]/60 mt-4">Você ainda não fez nenhum pedido.</p>
          <Link to="/loja" className="inline-block mt-6 bg-[#1A1A1A] text-[#F8F7F4] px-6 py-3 overline hover:bg-[#B89C65] transition-colors">Começar a comprar</Link>
        </div>
      ) : (
        <div className="space-y-5">
          {orders.map((o) => (
            <div key={o.id} data-testid={`order-${o.id}`} className="border border-[#1A1A1A]/10 p-6">
              <div className="flex flex-wrap justify-between items-center gap-3 pb-4 border-b border-[#1A1A1A]/10">
                <div>
                  <p className="text-xs text-[#1A1A1A]/40">Pedido #{o.id.slice(0, 8).toUpperCase()}</p>
                  <p className="text-sm text-[#1A1A1A]/60">{new Date(o.created_at).toLocaleDateString("pt-BR")}</p>
                </div>
                <span className={`overline px-3 py-1 ${o.status === "paid" || o.status === "delivered" ? "bg-[#1A1A1A] text-[#F8F7F4]" : "bg-[#EFEEEA] text-[#1A1A1A]"}`}>
                  {STATUS_LABEL[o.status] || o.status}
                </span>
              </div>
              <div className="flex flex-wrap gap-4 mt-4">
                {o.items.map((it, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <div className="w-12 h-16 bg-[#EFEEEA] overflow-hidden">
                      {it.image && <img src={it.image} alt="" className="w-full h-full object-cover" />}
                    </div>
                    <div className="text-sm">
                      <p className="text-[#1A1A1A]">{it.name}</p>
                      <p className="text-[#1A1A1A]/50 text-xs">Qtd {it.quantity}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div className="text-right mt-4 font-medium text-[#1A1A1A]">{formatBRL(o.total)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
